import { Icon } from '@/components/Icon/Icon';

import styles from './ProfileCard.module.css';

export interface ProfileCardProps {
  name: string;
  email: string;
  businessName?: string | null;
}

function initialsOf(name: string): string {
  const source = name.includes('@') ? (name.split('@')[0] ?? '') : name;
  const parts = source.split(/[\s._-]+/).filter(Boolean);
  return (parts.length > 1 ? parts[0][0] + parts[1][0] : source.slice(0, 2)).toUpperCase();
}

/** Who this account is, as the rest of the platform sees it. */
export function ProfileCard({ name, email, businessName }: ProfileCardProps) {
  return (
    <aside className={styles.card} aria-label="Your account">
      <span className={styles.avatar} aria-hidden="true">
        {initialsOf(name)}
      </span>
      <div className={styles.who}>
        <p className={styles.name}>{name}</p>
        <p className={styles.email}>{email}</p>
      </div>
      {businessName ? (
        <>
          <span className={styles.divider} />
          <p className={styles.business}>
            <Icon name="buildings" size="1.1rem" />
            {businessName}
          </p>
        </>
      ) : null}
    </aside>
  );
}
